export const nameValidation = "[a-zA-Z ]+$";
export const studentIdValidation = /^((15|14|13)[0-2]{1}[0-9]{3})$/;
export const phoneValidation = /^([+][8][4]|0)(3|5|7|8|9)[0-9]{8}$/;
export const facebookValidation = /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i;
